import { render, staticRenderFns } from "./type-add.vue?vue&type=template&id=14e25236&scoped=true"
import script from "./type-add.vue?vue&type=script&lang=js"
export * from "./type-add.vue?vue&type=script&lang=js"
import style0 from "./type-add.vue?vue&type=style&index=0&id=14e25236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e25236",
  null
  
)

export default component.exports